import { render } from "./VsNavbar.vue?vue&type=template&id=2326d055"
import script from "./VsNavbar.vue?vue&type=script&lang=js"
export * from "./VsNavbar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__